module.exports = __webpack_public_path__ + "static/media/ic-1.a8778fbb.svg";